import { isNativeApp } from '@/plugins/native-app/capacitor'

// Since user-scalable=no is a big no no for accessibility on the web
// let's only add it for native apps to support iPhone X
if (isNativeApp) {
  let viewport = document.querySelector('meta[name=viewport]')
  viewport.setAttribute('content', 'viewport-fit=cover, width=device-width, initial-scale=1.0, user-scalable=no')
}
